import { API_ROUTES } from "../constants/apiRoutes";
import { onApiCall } from "./CommonApi";

class CurrentUserService {
    getCurrentUserProfile() {
        return onApiCall({
            url: API_ROUTES.GET_CURRENT_USER_PROFILE,
            method: "GET",
        });
    }
    updateCurrentUserProfile(name, phoneNumber) {
        return onApiCall({
            url: API_ROUTES.UPDATE_CURRENT_USER_PROFILE,
            method: "PUT",
            data: {
                name,
                phone_number: phoneNumber,
            },
        });
    }
    changeCurrentUserAvatar(avatar) {
        console.log(avatar);
        const formData = new FormData();

        formData.append(
            "avatar",
            avatar,
            avatar.name
          );

        return onApiCall({
            url: API_ROUTES.CHANGE_CURRENT_USER_AVATAR,
            method: "POST",
            data: formData,
            // headers: {
            //     'Content-Type': 'multipart/form-data'
            //   }
        });
    }
}

export default new CurrentUserService();
